import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { usePlayer } from '../../hooks/PlayerProvider';
import { useIcons } from '../../hooks/useIcons';
import { useKeyboardHandler } from '../../hooks/useKeyboardHandler';
import { IconButton, IconButtonProps } from '../IconButton/IconButton';

export const PlayButton: FunctionComponent<IconButtonProps> = ({
  size,
  ...props
}) => {
  const player = usePlayer();
  const { Play } = useIcons();
  const { onClick } = props;

  const play = useCallback(() => {
    player.play();
  }, [player]);

  const handleKeydown = useCallback(
    (e: KeyboardEvent) => {
      if (e.code === 'Space' || e.code === 'KeyK') {
        play();
      }
    },
    [play]
  );

  useKeyboardHandler(handleKeydown);

  return (
    <IconButton
      size={size}
      {...props}
      onClick={(event) => {
        if (onClick) {
          onClick(event);
        }
        play();
      }}
    >
      <Play />
    </IconButton>
  );
};
